import { QRCodeSVG } from 'qrcode.react';
import { Translate as t } from '../../config/Translate';
// IMP-438: 날짜(전용) 포맷 SSoT — 앱 언어 locale 로 렌더. '-' 폴백 포함.
import { formatLicenseDateOnly } from '../../lib/licenseHelper';

// 미리보기 카드 — VoucherPrintModal QR 그리드 내 단일 카드.
// token 은 SPEC-RG-05 상 QR 불가 시 수동 입력용 공개 시리얼 — 별도 마스킹 불필요.
const VoucherPreviewCard = ({ qr, qrValue }) => {
    const isRenewal = qr.type === 'renewal' || qr.type === 'renew';
    const typeLabel = isRenewal ? t('license.label.renewal') : t('license.label.initial');
    const validLabel = formatLicenseDateOnly(qr.validuntil);

    return (
        <div className="border rounded p-2 text-center">
            {qr.token ? (
                <QRCodeSVG value={qrValue} size={100} />
            ) : (
                <div className="text-danger small">{t('common.message.error.invalidToken')}</div>
            )}
            <div className="small fw-bold mt-1">{typeLabel}</div>
            {qr.token && (
                // 인쇄(VoucherPrintArea)와 동일하게 라벨 없이 token 만 표시.
                // title: ellipsis 잘림 시 hover 로 전체 토큰 확인 가능.
                <div
                    className="small text-muted mt-1"
                    title={qr.token}
                    style={{ fontFamily: 'monospace', whiteSpace: 'nowrap', fontSize: '0.65rem', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                    {qr.token}
                </div>
            )}
            <div className="small text-muted">
                {t('license.field.validUntil')}: {validLabel}
            </div>
        </div>
    );
};

export default VoucherPreviewCard;
